<div [ngClass]="{ 'fullscreen-loader': isFullScreen, 'normal-loader': !isFullScreen }">
  <div fxFlex fxLayout="row" fxLayoutAlign="center center" class="spacing">
    <mat-spinner [diameter]="isFullScreen ? '50' : '16'"></mat-spinner>
    <p class="horizontal">{{ message || 'INTL_LOADING' | translate }}</p>
  </div>
</div>
